import React, { useState, useEffect, useCallback } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import LVCuadricula from "../../Componentes/Compuestos/Complejos/Generales/LVCuadricula";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import { LVGridCabeceraReporte } from "../../Componentes/Basicos/LVGridCabeceraReporte";
import LV_ART_Articulos_SelectorConGrid from "../../Componentes/Compuestos/Complejos/Articulos/LV_ART_Articulos_SelectorConGrid";
import LV_EEX_Clientes from "../../Componentes/Compuestos/Complejos/Clientes/LV_EEX_Clientes";
import { function_VEN_PVenta_Disposicion_CuentasFinancieras_Leer, function_VEN_PVenta_Disposicion_CuentasFinancieras_ListarDeTerminal } from "neftis7_apicaller/src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_CuentasFinancieras";
import { Column, Pager, Paging, TotalItem, Summary } from "devextreme-react/data-grid";
import ComboVenListaPreciosCabecera from "../../Componentes/Compuestos/Combos/ComboVenListaPreciosCabecera"
import ComboVenDocsVentaTipos from "../../Componentes/Compuestos/Combos/ComboVenDocsVentaTipos"
import { function_VEN_PVenta_Disposicion_Botones_Leer } from "neftis7_apicaller/src/funciones/VEN/PVenta/VEN_PVenta_Disposicion_Botones";
import LVSelectorPresentaciones from "../../Componentes/Selectores/LVSelectorPresentaciones";
import LVSelectorUnidadesMedida from "../../Componentes/Selectores/LVSelectorUnidadesMedida";
import LVSelectorPorcentaje from "../../Componentes/Selectores/LVSelectorPorcentaje";
import LVSelectorTamanos from "../../Componentes/Selectores/LVSelectorTamanos";
import { function_ABM_ART_Articulos_LeerPrecio } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import { useNavigate, useParams } from "react-router-dom";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_AsignacionDeTerminal } from "../../funciones/Varios"
import { function_VEN_Pedidos_Generar_JSON, function_VEN_Pedidos_Cabecera_Insertar } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";
import { function_ABM_IMP_PuntosFiscales_LeerPorTerminal, function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_PuntosFiscales";
import { function_VEN_DocsVenta_Recibo_Insertar, function_VEN_DocsVenta_Recibo_Generar_JSON } from "neftis7_apicaller/src/funciones/VEN/VEN";
import { function_ABM_IMP_Terminales_Leer } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_Terminales";
import { DateBox, NumberBox, TextBox } from "devextreme-react";
import RadioGroup from "devextreme-react/radio-group";
import SBox from '../../Componentes/Basicos/LVSelectBox';
import { function_STK_ART_Merma_InsertarMultiples, function_STK_ART_MermasMultiples_Generar_JSON } from "neftis7_apicaller/src/funciones/STK/STK_ART_Merma";
import { function_STK_ART_Consumo_InsertarMultiples, function_STK_ART_ConsumosMultiples_Generar_JSON } from "neftis7_apicaller/src/funciones/STK/STK_ART_Consumo";
import { FormateoFechaPara_yyyyMMdd, FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import { function_INV_Remitos_Cabecera_Insertar, function_INV_Remitos_Generar_JSON } from "neftis7_apicaller/src/funciones/INV/Remitos/INV_Remitos_Cabecera";
import { function_ABM_ZON_Plantas_Leer } from "neftis7_apicaller/src/funciones/ABM/ZON/ABM_ZON_Plantas";
import { function_VEN_Reservas_Cabecera_Eliminar, function_VEN_Reservas_Cabecera_Leer, function_VEN_Reservas_Cabecera_Listar } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import { function_VEN_DocsVenta_Cabecera_Eliminar, function_VEN_DocsVenta_Cabecera_ImpresionComandera, function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma, function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE } from "neftis7_apicaller/src/funciones/VEN/DocsVenta/VEN_DocsVenta_Cabecera";
import ComboAbmEexPersonasAutorizantes from "../../Componentes/Compuestos/Combos/ComboAbmEexPersonasAutorizantes";
import { function_ABM_EEX_Personas_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Personas";
import { function_VEN_Recibos_Cabecera_Eliminar } from "neftis7_apicaller/src/funciones/VEN/Recibos/VEN_Recibos_Cabecera";
import { function_ABM_EEX_ClientesLocaciones_Listar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesLocaciones";

//OK FORMATO Y CONTROL DE ERRORES
export const VEN_PuntoDeVenta_ = () => {
  let { IdReserva, Terminal = localStorage.getItem("Terminal") } = useParams();
  const navigate = useNavigate();
  const [idCliente, setIdClienteResponsable] = useState(0);
  const [idReserva, setIdReserva] = useState(IdReserva);
  const [idReservaParaCheckIn, setIdReservaParaCheckIn] = useState(IdReserva);
  const [importeReserva, setImporteReserva] = useState(0);
  const [idClienteDefault, setIdClienteDefault] = useState(0);
  const [codigoMoneda, setCodigoMoneda] = useState("PA");
  const [cotizacion, setCotizacion] = useState(1);
  const [codigoLP, setCodigoLP] = useState("");
  const [fecha, setFecha] = useState(new Date());
  const [factura, setfactura] = useState("");
  const [idPersona, setIdPersona] = useState(0);
  const [turno, setTurno] = useState(1);
  const [cantidadSegunPorcentaje, setCantidadSegunPorcentaje] = useState(1);
  const [idProveedorDelivery, setIdProveedorDelivery] = useState(0);
  const [proveedorDelivery1CodigoCuentaFinanciera, setProveedorDelivery1CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery1CodigoListaPrecios, setProveedorDelivery1CodigoListaPrecios] = useState("");
  const [proveedorDelivery2CodigoCuentaFinanciera, setProveedorDelivery2CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery2CodigoListaPrecios, setProveedorDelivery2CodigoListaPrecios] = useState("");
  const [proveedorDelivery3CodigoCuentaFinanciera, setProveedorDelivery3CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery3CodigoListaPrecios, setProveedorDelivery3CodigoListaPrecios] = useState("");
  const [proveedorDelivery4CodigoCuentaFinanciera, setProveedorDelivery4CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery4CodigoListaPrecios, setProveedorDelivery4CodigoListaPrecios] = useState("");
  const [proveedorDelivery5CodigoCuentaFinanciera, setProveedorDelivery5CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery5CodigoListaPrecios, setProveedorDelivery5CodigoListaPrecios] = useState("");
  const [proveedorDelivery6CodigoCuentaFinanciera, setProveedorDelivery6CodigoCuentaFinanciera] = useState("");
  const [proveedorDelivery6CodigoListaPrecios, setProveedorDelivery6CodigoListaPrecios] = useState("");
  const [idProveedorDeliveryReadOnly, setIdProveedorDeliveryReadOnly] = useState(false)
  const [idDocVentaTipo, setIdDocVentaTipo] = useState(1);
  const [codigoOperacionProveedorDelivery, setCodigoOperacionProveedorDelivery] = useState("");
  const [muestraControlesReservas, setMuestraControlesReservas] = useState(false)
  const [ventasPVPermiteVisualizarStock, setVentasPVPermiteVisualizarStock] = useState(true)
  const [ventasPVPermiteVenderConPrecioCero, setVentasPVPermiteVenderConPrecioCero] = useState(true)
  const [puntoVentaConBotonFCA, setPuntoVentaConBotonFCA] = useState(false)
  const [puntoVentaConBotonFCB, setPuntoVentaConBotonFCB] = useState(false)
  const [puntoVentaConBotonFCC, setPuntoVentaConBotonFCC] = useState(false)
  const [puntoVentaConBotonFCM, setPuntoVentaConBotonFCM] = useState(false)
  const [puntoVentaConBotonObservaciones, setPuntoVentaConBotonObservaciones] = useState(false)
  const [puntoVentaConBotonPedidos, setPuntoVentaConBotonPedidos] = useState(false)
  const [puntoVentaConBotonTKA, setPuntoVentaConBotonTKA] = useState(false)
  const [puntoVentaConBotonTKB, setPuntoVentaConBotonTKB] = useState(false)
  const [puntoVentaConBotonTKM, setPuntoVentaConBotonTKM] = useState(false)
  const [puntoVentaConBotonTKNCA, setPuntoVentaConBotonTKNCA] = useState(false)
  const [puntoVentaConBotonTKNCB, setPuntoVentaConBotonTKNCB] = useState(false)
  const [puntoVentaConBotonTKNCM, setPuntoVentaConBotonTKNCM] = useState(false)
  const [puntoVentaConBotonMerma, setPuntoVentaConBotonMerma] = useState(false)
  const [puntoVentaConBotonConsumo, setPuntoVentaConBotonConsumo] = useState(false)
  const [puntoVentaConBotonCheque, setPuntoVentaConBotonCheque] = useState(false)
  const [puntoVentaConBotonRemitoTransferencia, setPuntoVentaConBotonRemitoTransferencia] = useState(false)
  const [puntoVentaConBotonRemitoVenta, setPuntoVentaConBotonRemitoVenta] = useState(false)
  const [puntoVentaConControlesEnvio, setPuntoVentaConControlesEnvio] = useState(false)
  const [puntoVentaConControlesDelivery, setPuntoVentaConControlesDelivery] = useState(false)
  const [puntoVentaSePuedenModificarPrecios, setPuntoVentaSePuedenModificarPrecios] = useState(false)
  const [datosCabecera, setDatosCabecera] = useState([]);
  const [datosConceptoObservaciones, setDatosConceptoObservaciones] = useState([]);
  const [datosDetalle, setDatosDetalle] = useState([]);
  const [datosImpuestosDocVenta, setDatosImpuestosDocVenta] = useState([]);
  const [datosImpuestosRecibo, setDatosImpuestosRecibo] = useState([]);
  const [datosFPago, setDatosFPago] = useState([]);
  const [datosProveedorDelivery, setDatosProveedorDelivery] = useState([]);
  const [jsonDataLocal, setJSONDataLocal] = useState([]);
  const [idItemMasAlto, setIdItemMasAlto] = useState(1);
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);
  const [dataGrupos, setDataGrupos] = useState([]);
  const [dataBotones, setDataBotones] = useState([]);
  const [dataFormasPago, setDataFormasPago] = useState([]);
  const [dataFormasPagoTotal, setDataFormasPagoTotal] = useState([]);
  const [idGrupo, setIdGrupo] = useState(0);
  const [altoBotones, setAltoBotones] = useState(70);
  const [anchoBotones, setAnchoBotones] = useState(70);
  const [loadingGrupos, setLoadingGrupos] = useState(false)
  const [loadingBotones, setLoadingBotones] = useState(false)
  const [loadingFormasPago, setLoadingFormasPago] = useState(false)
  const [loadingReservas, setLoadingReservas] = useState(false)
  const [codigoArticulo, setCodigoArticulo] = useState("");
  const [codigoPresentacion, setCodigoPresentacion] = useState("");
  const [codigoTamano, setCodigoTamano] = useState("");
  const [codigoUM, setCodigoUM] = useState("");
  const [articulo, setArticulo] = useState("");
  const [reservable, setReservable] = useState("");
  const [presentacion, setPresentacion] = useState("");
  const [tamano, setTamano] = useState("");
  const [um, setUM] = useState("");
  const [idBotonSeleccionado, setIdBotonSeleccionado] = useState(0);
  const [totalImporteDelComponenteSelectorArticulos, setTotalImporteDelComponenteSelectorArticulos] = useState(0);
  const [totalImporteNetoDelComponenteSelectorArticulos, setTotalImporteNetoDelComponenteSelectorArticulos] = useState(0);
  const [totalImporteDelComponenteSelectorCFs, setTotalImporteDelComponenteSelectorCFs] = useState(0);
  const [showPopupPresentaciones, setShowPopupPresentaciones] = useState(false);
  const [showPopupTamanos, setShowPopupTamanos] = useState(false);
  const [showPopupUnidadesMedida, setShowPopupUnidadesMedida] = useState(false);
  const [showPopupPorcentaje, setShowPopupPorcentaje] = useState(false);
  const [statesUpdatedVacio, setStatesUpdatedVacio] = useState(false);
  const [statesUpdatedLleno, setStatesUpdatedLleno] = useState(false);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [mostrarAutorizacion, setMostrarAutorizacion] = useState(false);
  const [idPersonaNCAutorizante, setIdPersonaNCAutorizante] = useState(null);
  const [passwordNC, setPasswordNC] = useState("");
  const [tipoNC, setTipoNC] = useState("");
  const [autorizacionEnProceso, setAutorizacionEnProceso] = useState(false);
  const [mostrarBuscadorReservas, setMostrarBuscadorReservas] = useState(false);
  const [reservasEncontradas, setReservasEncontradas] = useState([]);
  const [soloNC, setSoloNC] = useState(false);
  const [PVEsElectronico, setPVEsElectronico] = useState(false);
  const [FechaDesdeBuscadorReservas, setFechaDesdeBuscadorReservas] = useState(new Date());
  const [FechaHastaBuscadorReservas, setFechaHastaBuscadorReservas] = useState(new Date());
  const [comportamiento, setComportamiento] = useState(1);

  const { VEN_PVenta_Disposicion_Grupos: { function_VEN_PVenta_Disposicion_Grupos_Listar }, COM_Cotizaciones_Cabecera } = require('neftis7_apicaller');
  const { VEN_PVenta_Disposicion_Botones: { function_VEN_PVenta_Disposicion_Botones_ListarPorGrupo } } = require('neftis7_apicaller');
  const { Varios: { ObtieneParametros, TratamientoDeVariableBoolean } } = require('neftis7_apicaller');

  const dataCierres = [
    {
      "IdBoton": 1,
      "Descripcion": "FC B",
      "Habilitado": puntoVentaConBotonFCB,
      "Color": -6432178,
    },
    {
      "IdBoton": 2,
      "Descripcion": "FC A",
      "Habilitado": puntoVentaConBotonFCA,
      "Color": -14726787,
    },
    {
      "IdBoton": 3,
      "Descripcion": "TK M",
      "Habilitado": puntoVentaConBotonTKM,
      "Color": -10475482,
    },
    {
      "IdBoton": 4,
      "Descripcion": "FC M",
      "Habilitado": puntoVentaConBotonFCM,
      "Color": -10475482,
    },
    {
      "IdBoton": 5,
      "Descripcion": "NC B",
      "Habilitado": puntoVentaConBotonFCB,
      "Color": -6432178,
    },
    {
      "IdBoton": 6,
      "Descripcion": "NC A",
      "Habilitado": puntoVentaConBotonFCA,
      "Color": -14726787,
    },
    {
      "IdBoton": 7,
      "Descripcion": "NC M",
      "Habilitado": puntoVentaConBotonTKM,
      "Color": -10475482,
    },
    {
      "IdBoton": 8,
      "Descripcion": "NC M",
      "Habilitado": puntoVentaConBotonFCM,
      "Color": -10475482,
    },
    {
      "IdBoton": 9,
      "Descripcion": "MERMA",
      "Habilitado": puntoVentaConBotonMerma,
      "Color": -62850,
    },
    {
      "IdBoton": 10,
      "Descripcion": "CONSUMO",
      "Habilitado": puntoVentaConBotonConsumo,
      "Color": -62850,
    },
    {
      "IdBoton": 11,
      "Descripcion": "PEDIDO",
      "Habilitado": puntoVentaConBotonPedidos,
      "Color": -9490024,
    },
    {
      "IdBoton": 12,
      "Descripcion": "REMITO",
      "Habilitado": puntoVentaConBotonRemitoVenta,
      "Color": -14330269,
    }
  ];

  const recargaDeLaPagina = () => {
    /*
    setIdClienteResponsable(0);
    setIdReserva(0);
    setIdReservaParaCheckIn(0);
    setImporteReserva(0);
    setIdClienteDefault(0);
    setCodigoMoneda("PA");
    setCotizacion(1);
    setCodigoLP("");
    setFecha(new Date());
    setfactura("");
    setIdPersona(0);
    setTurno(1);
    setCantidadSegunPorcentaje(1);
    setIdProveedorDelivery(0);
    setIdProveedorDeliveryReadOnly(false);
    setIdDocVentaTipo(1);
    setCodigoOperacionProveedorDelivery("");
    setMuestraControlesReservas(false);
    setVentasPVPermiteVisualizarStock(true);
    setVentasPVPermiteVenderConPrecioCero(true);
    setPuntoVentaConBotonFCA(false);
    setPuntoVentaConBotonFCB(false);
    setPuntoVentaConBotonFCC(false);
    setPuntoVentaConBotonFCM(false);
    setPuntoVentaConBotonObservaciones(false);
    setPuntoVentaConBotonPedidos(false);
    setPuntoVentaConBotonTKA(false);
    setPuntoVentaConBotonTKB(false);
    setPuntoVentaConBotonTKM(false);
    setPuntoVentaConBotonTKNCA(false);
    setPuntoVentaConBotonTKNCB(false);
    setPuntoVentaConBotonTKNCM(false);
    setPuntoVentaConBotonMerma(false);
    setPuntoVentaConBotonConsumo(false);
    setPuntoVentaConBotonCheque(false);
    setPuntoVentaConBotonRemitoTransferencia(false);
    setPuntoVentaConBotonRemitoVenta(false);
    setPuntoVentaConControlesEnvio(false);
    setPuntoVentaConControlesDelivery(false);
    setPuntoVentaSePuedenModificarPrecios(false);
    setDatosCabecera([]);
    setDatosConceptoObservaciones([]);
    setDatosDetalle([]);
    setDatosImpuestosDocVenta([]);
    setDatosImpuestosRecibo([]);
    setDatosFPago([]);
    setDatosProveedorDelivery([]);
    setJSONDataLocal([]);
    setIdItemMasAlto(1);
    setGlobalUsaArticulosConPresentacion(false);
    setGlobalUsaArticulosConTamano(false);
    setGlobalUsaArticulosConUnidadDeMedida(false);
    setDataGrupos([]);
    setDataBotones([]);
    setDataFormasPago([]);
    setIdGrupo(0);
    setAltoBotones(70);
    setAnchoBotones(70);
    setLoadingGrupos(false);
    setLoadingBotones(false);
    setLoadingFormasPago(false);
    setCodigoArticulo("");
    setCodigoPresentacion("");
    setCodigoTamano("");
    setCodigoUM("");
    setArticulo("");
    setReservable("");
    setPresentacion("");
    setTamano("");
    setUM("");
    setIdBotonSeleccionado(0);
    setTotalImporteDelComponenteSelectorArticulos(0);
    setTotalImporteNetoDelComponenteSelectorArticulos(0);
    setTotalImporteDelComponenteSelectorCFs(0);
    setShowPopupPresentaciones(false);
    setShowPopupTamanos(false);
    setShowPopupUnidadesMedida(false);
    setShowPopupPorcentaje(false);
    setStatesUpdatedVacio(false);
    setStatesUpdatedLleno(false);
    setCierreEnProceso(false);
    setMostrarAutorizacion(false);
    setIdPersonaNCAutorizante(null);
    setPasswordNC("");
    setTipoNC("");
    setAutorizacionEnProceso(false);
    */

    // Navego sin recargar la página completa
    navigate(`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}`);

    //navigate(`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}`) //CON ESTO lIMPIO SI FACTURE RESERVA        
    window.location.reload();
  }

  const buscarReservas = async () => {
    setLoadingReservas(true)
    setMostrarBuscadorReservas(true);
    try {
      const resultReservas = await function_VEN_Reservas_Cabecera_Listar(FormateoFechaPara_yyyyMMdd(FechaDesdeBuscadorReservas), FormateoFechaPara_yyyyMMdd(FechaHastaBuscadorReservas));

      setReservasEncontradas(resultReservas.data || []);

    } catch (error) {
      alert("Error al buscar reservas");
    }
    setLoadingReservas(false)
  };

  const confirmarAutorizacionNC = async (tipoNC) => {
    if (!idPersonaNCAutorizante) {
      alert("Debe seleccionar quién autoriza.");
      return;
    }

    if (!passwordNC) {
      alert("Debe ingresar una contraseña válida.");
      return;
    }

    const resultPersonaAutorizante = await function_ABM_EEX_Personas_Leer(idPersonaNCAutorizante)
    if (passwordNC !== resultPersonaAutorizante.data.Password) {
      alert("Contraseña inválida.")
      return
    }

    setAutorizacionEnProceso(true);

    try {
      if (tipoNC == 5) {
        //NC B
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(12)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        try {
          if (PVEsElectronico) {
            await function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE(DocVentaRecibo.data.codigoGenerado1)
          }

          await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
        } catch (error) {
          alert("Error: " + error)
          const respuesta = window.confirm("❌ El Documento de Venta no pudo ser validado en ARCA.\n\n¿Desea anularlo?\n\n- Si selecciona ACEPTAR, se anulará el comprobante.\n- Si selecciona CANCELAR, se intentará validar automáticamente en el futuro, pero sin seguridad de éxito.");

          if (respuesta) {
            // El usuario eligió "SI"

            //alert("Anulación automática no disponible por el momento. Solicite al supervisor la anulación del Comprobante ID: " + DocVentaRecibo.data.codigoGenerado1 + ". Tome nota de este número.")
            await function_VEN_Recibos_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado2);
            await function_VEN_DocsVenta_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado1);
          } else {
            // Marcar para validacion posterior
            await function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma(DocVentaRecibo.data.codigoGenerado1)
          }
        } finally {
          setAutorizacionEnProceso(false);
        }
      }

      if (tipoNC == 6) {
        //NC A
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(2)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        try {
          if (PVEsElectronico) {
            await function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE(DocVentaRecibo.data.codigoGenerado1)
          }

          await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
        } catch (error) {
          alert("Error: " + error)
          const respuesta = window.confirm("❌ El Documento de Venta no pudo ser validado en ARCA.\n\n¿Desea anularlo?\n\n- Si selecciona ACEPTAR, se anulará el comprobante.\n- Si selecciona CANCELAR, se intentará validar automáticamente en el futuro, pero sin seguridad de éxito.");

          if (respuesta) {
            // El usuario eligió "SI"

            //alert("Anulación automática no disponible por el momento. Solicite al supervisor la anulación del Comprobante ID: " + DocVentaRecibo.data.codigoGenerado1 + ". Tome nota de este número.")
            await function_VEN_Recibos_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado2);
            await function_VEN_DocsVenta_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado1);
          } else {
            // Marcar para validacion posterior
            await function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma(DocVentaRecibo.data.codigoGenerado1)
          }
        } finally {
          setAutorizacionEnProceso(false);
        }
      }

      if (tipoNC == 7) {
        //NC M
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(72)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
      }

      if (tipoNC == 8) {
        //NC M
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(42)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
      }

      if (idReservaParaCheckIn > 0) {
        //SOLO PARA RESERVAS
        const deseaAnular = window.confirm(
          `A la reserva Nº ${idReservaParaCheckIn} se le realizó una N.C. ¿Deseas anular la reserva ahora?`
        );

        if (deseaAnular) {
          try {
            await function_VEN_Reservas_Cabecera_Eliminar(idReservaParaCheckIn)
            alert("Se ha eliminado la Reserva Nº " + idReservaParaCheckIn)
          } catch (error) {
            alert("Error al eliminar la Reserva: " + error)
          }
        }
      }

      recargaDeLaPagina()

    } catch (error) {
      alert("Error: " + error)
    } finally {
      setAutorizacionEnProceso(false);
    }
  };

  const CierreDocumentoVenta = async (IdTipo) => {
    setAutorizacionEnProceso(true);

    try {
      const PVDV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 4, IdTipo)
      const PVR = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 8, 1)
      const esElectronico = PVDV.data[0].EsElectronico
      setPVEsElectronico(esElectronico)

      if (!PVDV.data || PVDV.data.length === 0) {
        throw new Error("No se definió Punto de Venta Fiscal para Documentos de Venta para esta Terminal")
      }

      if (!PVR.data || PVR.data.length === 0) {
        throw new Error("No se definió Punto de Venta Fiscal para Documentos de Venta para esta Terminal")
      }

      const ProximoNumeroDV = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PVDV.data[0].CodigoPuntoFiscal, 4, IdTipo)
      const ProximoNumeroR = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PVR.data[0].CodigoPuntoFiscal, 8, 1)

      if (!ProximoNumeroDV.data || ProximoNumeroDV.data.length === 0) {
        throw new Error("No se pudo obtener el Próximo Número de Documentos de Venta")
      }

      if (!ProximoNumeroR.data || ProximoNumeroR.data.length === 0) {
        throw new Error("No se pudo obtener el Próximo Número de Recibos")
      }

      const concepto = datosConceptoObservaciones?.concepto || '';
      const observaciones = datosConceptoObservaciones?.observaciones || '';
      const detalle = datosDetalle || [];
      const detalleFPago = datosFPago || [];
      const numeroFantasiaDV = ProximoNumeroDV?.data?.NumeroFantasia || '0000-00000000'
      const ptoVtaDV = ProximoNumeroDV?.data?.PtoVta || '0000'
      const numeroDV = ProximoNumeroDV?.data?.Numero || '00000000'
      const numeroFantasiaR = ProximoNumeroR?.data?.NumeroFantasia || '0000-00000000'
      const ptoVtaR = ProximoNumeroR?.data?.PtoVta || '0000'
      const numeroR = ProximoNumeroR?.data?.Numero || '00000000'

      const idClienteFinal = idCliente === 0 ? idClienteDefault : idCliente;

      if ([1, 2, 3, 31, 32, 33].includes(IdTipo)) {
        if (idClienteFinal === idClienteDefault) {
          throw new Error("No se puede usar el Cliente Consumidor Final en Documentos A o E")
        }
      }

      const Documento = await function_VEN_DocsVenta_Recibo_Generar_JSON(0, IdTipo, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), idClienteFinal,
        numeroFantasiaDV, ptoVtaDV, numeroDV, codigoMoneda, cotizacion,
        0, 0, concepto, observaciones, 0, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), "", FormateoFechaPara_yyyyMMdd_HHmmss(fecha), "DO", Terminal,
        turno, idProveedorDelivery, codigoOperacionProveedorDelivery, "", "", 0, 0, null, null, idPersona,
        detalle, datosImpuestosDocVenta, [], [], [], 0, numeroFantasiaR,
        ptoVtaR, numeroR, 0, 0, detalleFPago, datosImpuestosRecibo, [], [], [])

      const DocVentaRecibo = await function_VEN_DocsVenta_Recibo_Insertar(Documento, true)

      return { DocVentaRecibo, esElectronico }
    } catch (error) {
      throw error
    } finally {
      setAutorizacionEnProceso(false);
    }
  }

  const handleCustomizeTotal = useCallback((e) => {
    try {
      const formattedValue = e.value.toFixed(1);
      setTotalImporteDelComponenteSelectorCFs(e.value);
      return `T: ${formattedValue}`;
    } catch (error) {
      alert(error)
    }
  }, []);

  const handleOnValueChanged_CodigoListaPrecios = (e) => {
    try {
      setCodigoLP(e.value);
    } catch (error) {
      alert(error)
    }
  }

  const handleOnTotalImporteDelComponenteChange_ = (newTotal, newNetoTotal) => {
    try {
      setTotalImporteDelComponenteSelectorArticulos(newTotal);
      setTotalImporteNetoDelComponenteSelectorArticulos(newNetoTotal)
    } catch (error) {
      alert(error)
    }
  };

  const handleonButtOnClick_Facturar = async () => {
    try {
      if (!idReserva || idReserva < 1) {
        throw new Error("El número de Reserva debe ser mayor a CERO.");
      }
      setShowPopupPorcentaje(true)
    } catch (error) {
      setIdReserva(0)
      alert(error)
    }
  };

  const handleonButtonClick_Grupo = async (IdGrupo) => {
    try {
      setIdGrupo(IdGrupo);
    } catch (error) {
      alert(error)
    }
  };

  const handleonButtonClick_Boton = async (IdBoton) => {
    try {
      setIdBotonSeleccionado(IdBoton)
      setCodigoArticulo("");
      setReservable(false)
      setCodigoPresentacion("");
      setCodigoTamano("");
      setCodigoUM("");
      const PV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 4, 11)
      setCodigoLP(PV.data[0].CodigoListaPrecios)
      setArticulo("");
      setPresentacion("");
      setTamano("");
      setUM("");
      setShowPopupPresentaciones(false)
      setShowPopupTamanos(false)
      setShowPopupUnidadesMedida(false)
      setShowPopupPorcentaje(false)

      setStatesUpdatedVacio(true);
    } catch (error) {
      alert(error)
    }
  };

  const handleonButtonClick_FPago = async (IdBotonFP) => {
    try {
      if (totalImporteDelComponenteSelectorArticulos > totalImporteDelComponenteSelectorCFs) {
        const datosBoton = await function_VEN_PVenta_Disposicion_CuentasFinancieras_Leer(Terminal, IdBotonFP);

        const nuevaFP = {
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
          CodigoCuentaFinanciera: datosBoton.data[0].CodigoCuentaFinanciera,
          CuentaFinanciera: datosBoton.data[0].Descripcion,
          Cotizacion: datosBoton.data[0].Cotizacion,
          Importe: parseFloat((totalImporteDelComponenteSelectorArticulos - totalImporteDelComponenteSelectorCFs).toFixed(1))
        };

        setDatosFPago(datosFPago => [...datosFPago, nuevaFP]);
      } else {
        alert('Ya se cargaron Formas de Pago para cubrir el total del Documento.')
      }
    } catch (error) {
      alert(error)
    }
  };

  const handleonButtonClick_Cierre = async (IdBoton) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      const resultTerminal = await function_ABM_IMP_Terminales_Leer(Terminal)
      const CodigoUbicacionVenta = resultTerminal?.data[0]?.CodigoUbicacionStockDeVenta || '';

      const updatedDatosDetalle = datosDetalle.map(item => {
        // Si el campo CodigoUbicacion ya existe, cambia su valor al de la Terminal
        if (item.hasOwnProperty('CodigoUbicacion')) {
          item.CodigoUbicacion = CodigoUbicacionVenta;
        } else {
          // Si el campo CodigoUbicacion no existe, lo agrega con el valor de la Terminal
          item.CodigoUbicacion = CodigoUbicacionVenta;
        }

        item.CodigoUbicacionIngreso = CodigoUbicacionVenta;
        item.CodigoUbicacionEgreso = CodigoUbicacionVenta;
        return item;
      });
      setDatosDetalle(updatedDatosDetalle)

      if (IdBoton === 1) {
        //FC B
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(11)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        try {
          if (esElectronico) {
            await function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE(DocVentaRecibo.data.codigoGenerado1)
          }

          await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
        } catch (error) {
          alert("Error: " + error)
          const respuesta = window.confirm("❌ El Documento de Venta no pudo ser validado en ARCA.\n\n¿Desea anularlo?\n\n- Si selecciona ACEPTAR, se anulará el comprobante.\n- Si selecciona CANCELAR, se intentará validar automáticamente en el futuro, pero sin seguridad de éxito.");

          if (respuesta) {
            // El usuario eligió "SI"

            //alert("Anulación automática no disponible por el momento. Solicite al supervisor la anulación del Comprobante ID: " + DocVentaRecibo.data.codigoGenerado1 + ". Tome nota de este número.")
            await function_VEN_Recibos_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado2);
            await function_VEN_DocsVenta_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado1);
          } else {
            // Marcar para validacion posterior
            await function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma(DocVentaRecibo.data.codigoGenerado1)
          }
        }
      }

      if (IdBoton === 2) {
        //FC A
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(1)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        try {
          if (esElectronico) {
            await function_VEN_DocsVenta_Cabecera_ValidacionARCA_CAE(DocVentaRecibo.data.codigoGenerado1)
          }

          await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
        } catch (error) {
          alert("Error: " + error)
          const respuesta = window.confirm("❌ El Documento de Venta no pudo ser validado en ARCA.\n\n¿Desea anularlo?\n\n- Si selecciona ACEPTAR, se anulará el comprobante.\n- Si selecciona CANCELAR, se intentará validar automáticamente en el futuro, pero sin seguridad de éxito.");

          if (respuesta) {
            // El usuario eligió "SI"

            //alert("Anulación automática no disponible por el momento. Solicite al supervisor la anulación del Comprobante ID: " + DocVentaRecibo.data.codigoGenerado1 + ". Tome nota de este número.")
            await function_VEN_Recibos_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado2);
            await function_VEN_DocsVenta_Cabecera_Eliminar(DocVentaRecibo.data.codigoGenerado1);
          } else {
            // Marcar para validacion posterior
            await function_VEN_DocsVenta_Cabecera_MarcaParaValidacionAutonoma(DocVentaRecibo.data.codigoGenerado1)
          }
        }
      }

      if (IdBoton === 3) {
        //TK M
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(71)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
      }

      if (IdBoton === 4) {
        //FC M
        const { DocVentaRecibo, esElectronico } = await CierreDocumentoVenta(41)
        localStorage.setItem("ultimoDocVentaGenerado", DocVentaRecibo.data.codigoGenerado1);

        await function_VEN_DocsVenta_Cabecera_ImpresionComandera(DocVentaRecibo.data.codigoGenerado1)
      }

      if (IdBoton === 5) {
        setMostrarAutorizacion(true)
        setTipoNC(5)
      }

      if (IdBoton === 6) {
        setMostrarAutorizacion(true)
        setTipoNC(6)
      }

      if (IdBoton === 7) {
        setMostrarAutorizacion(true)
        setTipoNC(7)
      }

      if (IdBoton === 8) {
        //NC M

        setMostrarAutorizacion(true)
        setTipoNC(8)
      }

      if (IdBoton === 9) {
        //MERMA
        const detalle = datosDetalle || [];

        const operaciones = await function_STK_ART_MermasMultiples_Generar_JSON(detalle, "", FormateoFechaPara_yyyyMMdd_HHmmss(fecha))
        await function_STK_ART_Merma_InsertarMultiples(operaciones)
      }

      if (IdBoton === 10) {
        //CONSUMO
        const detalle = datosDetalle || [];

        const operaciones = await function_STK_ART_ConsumosMultiples_Generar_JSON(detalle, "",
          FormateoFechaPara_yyyyMMdd_HHmmss(fecha), 0)
        await function_STK_ART_Consumo_InsertarMultiples(operaciones)
      }

      if (IdBoton === 11) {
        //PEDIDO
        const PV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 19, 1)

        const ProximoNumero = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PV.data[0].CodigoPuntoFiscal, 19, 1)

        const concepto = datosConceptoObservaciones?.concepto || '';
        const observaciones = datosConceptoObservaciones?.observaciones || '';
        const detalle = datosDetalle || [];
        const numeroFantasia = ProximoNumero?.data?.NumeroFantasia || '0000-00000000'
        const ptoVta = ProximoNumero?.data?.PtoVta || '0000'
        const numero = ProximoNumero?.data?.Numero || '00000000'

        const resultLocacionesCliente = await function_ABM_EEX_ClientesLocaciones_Listar(idCliente)
        const CodigoLocacion = resultLocacionesCliente.data[0].CodigoLocacionCliente

        const Documento = await function_VEN_Pedidos_Generar_JSON(0, 1, idDocVentaTipo, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), idCliente,
          numeroFantasia, ptoVta, numero, factura, codigoMoneda, cotizacion,
          0, 0, concepto, observaciones, false, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), "", false, 0, false, "", "",
          null, null, "DO", false, false, false, false, idPersona, 0,
          CodigoLocacion, idProveedorDelivery, codigoOperacionProveedorDelivery, "", 0, 0, detalle, [], [])

        const Pedido = await function_VEN_Pedidos_Cabecera_Insertar(Documento)
      }

      if (IdBoton === 12) {
        //REMITO
        const PV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 16, 1)

        const ProximoNumero = await function_ABM_IMP_PuntosFiscales_ObtenerProximoNumeroPorCodigoPuntoFiscal(PV.data[0].CodigoPuntoFiscal, 16, 1)

        const concepto = datosConceptoObservaciones?.concepto || '';
        const observaciones = datosConceptoObservaciones?.observaciones || '';
        const detalle = datosDetalle || [];
        const numeroFantasia = ProximoNumero?.data?.NumeroFantasia || '0000-00000000'
        const ptoVta = ProximoNumero?.data?.PtoVta || '0000'
        const numero = ProximoNumero?.data?.Numero || '00000000'

        const Documento = await function_INV_Remitos_Generar_JSON(0, 1, FormateoFechaPara_yyyyMMdd_HHmmss(fecha), idCliente,
          numeroFantasia, ptoVta, numero, codigoMoneda, cotizacion,
          0, 0, 0, concepto, observaciones, "", 0, false,
          "", "", "", "", 0, "", "", "", 0, "", "", "", "", "", "", "", "", "", "", detalle, [], [])

        const Pedido = await function_INV_Remitos_Cabecera_Insertar(Documento)
      }

      if (idReservaParaCheckIn > 0) {
        //RESERVA
        if (IdBoton == 1 || IdBoton == 2 || IdBoton == 3 || IdBoton == 4) {
          //SOLO FACTURACION (NO NOTA CREDITO)
          const deseaCheckIn = window.confirm(
            `La reserva Nº ${idReservaParaCheckIn} fué facturada. ¿Deseas realizar el Check-In ahora?`
          );

          if (deseaCheckIn) {
            navigate(`/VEN_Reservas_CheckIn/${idReservaParaCheckIn}`);
            return;
          } else {
            recargaDeLaPagina()
          }
        }
      }
      else {
        //NO ES RESERVA
        if (IdBoton != 5 && IdBoton != 6 && IdBoton != 7 && IdBoton != 8) {
          //NO ES NC
          recargaDeLaPagina()
        }
      }
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  };

  const handleOnSelectedCodigoChange_Presentacion = (codigo, descripcion) => {
    try {
      setCodigoPresentacion(codigo);
      setPresentacion(descripcion);
      setShowPopupPresentaciones(false);
      setStatesUpdatedLleno(true)
    } catch (error) {
      alert(error)
    }
  };

  const handleOnSelectedCodigoChange_Tamano = (codigo, descripcion) => {
    try {
      setCodigoTamano(codigo);
      setTamano(descripcion);
      setShowPopupTamanos(false);
      setStatesUpdatedLleno(true)
    } catch (error) {
      alert(error)
    }
  };

  const handleOnSelectedCodigoChange_UnidadMedida = (codigo, descripcion) => {
    try {
      setCodigoUM(codigo);
      setUM(descripcion);
      setShowPopupUnidadesMedida(false)
      setStatesUpdatedLleno(true)
    } catch (error) {
      alert(error)
    }
  };

  const handleOnSelectedCodigoChange_Porcentaje = async (codigo, descripcion, resultReserva) => {
    try {
      if (codigo === "") {
        setShowPopupPorcentaje(false);
        return; // No hacer nada si el código está vacío
      }

      if (codigo === "-1") {
        setIdReserva(0)
        setImporteReserva(0)
        setShowPopupPorcentaje(false);
        return; // No hacer nada si el código está vacío
      }

      if (codigo === "NC") {
        setCantidadSegunPorcentaje(1);
        setStatesUpdatedLleno(true);
        setShowPopupPorcentaje(false)
        setSoloNC(true)
      }

      if (codigo && codigo !== "NC") {
        setCantidadSegunPorcentaje(codigo);
        setStatesUpdatedLleno(true);
      }
      setShowPopupPorcentaje(false); // Ocultar el popup una vez seleccionado

      //ACEPTACION DE FORMULARIO DE DESLINDE DE RESPONSABILIDAD
      /*
      Boolean FormularioAceptado = false;

                App_Neftis_Ventas.Reservas.frmReservasTerminosCondiciones Form = new Reservas.frmReservasTerminosCondiciones();
                    Form.StartPosition = FormStartPosition.CenterScreen;
                    Form.ShowDialog();
                   */

      setIdClienteResponsable(resultReserva.data.IdClienteGenerador)
      setImporteReserva(resultReserva.data.ImporteTotal)

      let DescripcionCompleta = ""
      if (resultReserva.data && resultReserva.data.Detalles) {
        resultReserva.data.Detalles.forEach(detalle => {
          if (DescripcionCompleta === "") {
            DescripcionCompleta = "RESERVA: " + resultReserva.data.IdReserva + " -H:" + detalle.FechaReservaInicio
          } else {
            DescripcionCompleta = DescripcionCompleta + " - RESERVA: " + resultReserva.data.IdReserva + " -H:" + detalle.FechaReservaInicio
          }
        });

        setCodigoArticulo("DEF");
        setArticulo(DescripcionCompleta);
        setReservable(true);

        setCodigoPresentacion("DEF");
        setCodigoTamano("DEF");
        setCodigoUM("UN");
        setPresentacion("UNICA");
        setTamano("UNICA");
        setUM("UNIDAD");

        setStatesUpdatedLleno(true)
      }
    } catch (error) {
      alert(error)
    }
  };

  useEffect(() => {
    //CHEQUEO DE TERMINAL
    const ControlDeTerminal = async () => {
      await function_AsignacionDeTerminal(Terminal, true)

      while (Terminal < 1 || !Terminal) {
        try {
          Terminal = await function_AsignacionDeTerminal(prompt("Por favor, ingrese el número de Terminal:"))
          window.location.reload()
        } catch (error) {
          alert(error)
        }
      }
    }
    ControlDeTerminal()

    if (Terminal > 0) {
      const functionAsinc = async () => {
        //LECTURA DE TERMINAL
        const resultTerminal = await function_ABM_IMP_Terminales_Leer(Terminal)
        setMuestraControlesReservas(resultTerminal.data[0].HabilitacionTabReservas)
        setPuntoVentaConBotonConsumo(resultTerminal.data[0].HabilitacionBotonConsumo)
        setPuntoVentaConBotonMerma(resultTerminal.data[0].HabilitacionBotonMerma)
        setPuntoVentaConBotonCheque(resultTerminal.data[0].HabilitacionBotonCheque)
        setPuntoVentaConBotonRemitoTransferencia(resultTerminal.data[0].HabilitacionBotonRemitoTransferencia)
        setPuntoVentaConBotonRemitoVenta(resultTerminal.data[0].HabilitacionBotonRemitoVenta)
        setPuntoVentaConControlesEnvio(resultTerminal.data[0].HabilitacionControlesEnvio)
        setPuntoVentaSePuedenModificarPrecios(resultTerminal.data[0].PuntoVentaSePuedenModificarPrecios)

        setIdPersona(resultTerminal.data[0].IdPersonaUltimaApertura)

        //CONTROL DE APERTURA EFECTIVO
        if (resultTerminal.data[0].VerificacionSaldoObligatoriaEnApertura) {
          if (resultTerminal.data[0].FechaUltimaCargaSaldoApertura < resultTerminal.data[0].FechaUltimaCargaSaldoCierre) {
            navigate(`/VEN_PuntoDeVenta_Administracion/${Terminal}`)
          }
          else {
            console.log("NO Necesito Apertura")
          }
        }

        //CONTROL DE APERTURA STOCK 1
        if (resultTerminal.data[0].VerificacionStockObligatoriaEnApertura) {
          if (resultTerminal.data[0].FechaUltimaVerificacionStockApertura < resultTerminal.data[0].FechaUltimaVerificacionStockCierre) {
            console.log("Necesito Apertura")

            window.location.reload()
          }
          else {
            console.log("NO Necesito Apertura")
          }
        }

        //CONTROL DE APERTURA STOCK 2
        if (resultTerminal.data[0].VerificacionStockSecundariaObligatoriaEnApertura) {
          if (resultTerminal.data[0].FechaUltimaVerificacionStockSecundariaApertura < resultTerminal.data[0].FechaUltimaVerificacionStockSecundariaCierre) {
            console.log("Necesito Apertura")

            window.location.reload()
          }
          else {
            console.log("NO Necesito Apertura")
          }
        }

        //CONTROL DE APERTURA STOCK 3
        if (resultTerminal.data[0].VerificacionStockTerciariaObligatoriaEnApertura) {
          if (resultTerminal.data[0].FechaUltimaVerificacionStockTerciariaApertura < resultTerminal.data[0].FechaUltimaVerificacionStockTerciariaCierre) {
            console.log("Necesito Apertura")

            window.location.reload()
          }
          else {
            console.log("NO Necesito Apertura")
          }
        }

        //GENERACION DE BOTONES DE GRUPO
        setLoadingGrupos(true);
        try {
          const PV = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, 4, 11)
          setCodigoLP(PV.data[0].CodigoListaPrecios)
        } catch (error) {
          alert(error)
        }

        try {
          const datosModificadores = await ObtieneParametros();
          setGlobalUsaArticulosConPresentacion(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion))
          setGlobalUsaArticulosConTamano(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano))
          setGlobalUsaArticulosConUnidadDeMedida(await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida))
          setCodigoMoneda(datosModificadores.GlobalMonedaBase)
          setIdClienteDefault(datosModificadores.VentasClienteConsumidorFinal)
          setCodigoLP(datosModificadores.VentasListaPreciosParaPuntoVenta)
          setVentasPVPermiteVenderConPrecioCero(datosModificadores.VentasPVPermiteVenderConPrecioCero)

          setProveedorDelivery1CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery1CuentaFinanciera)
          setProveedorDelivery1CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery1ListaDePrecios)
          setProveedorDelivery2CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery2CuentaFinanciera)
          setProveedorDelivery2CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery2ListaDePrecios)
          setProveedorDelivery3CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery3CuentaFinanciera)
          setProveedorDelivery3CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery3ListaDePrecios)
          setProveedorDelivery4CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery4CuentaFinanciera)
          setProveedorDelivery4CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery4ListaDePrecios)
          setProveedorDelivery5CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery5CuentaFinanciera)
          setProveedorDelivery5CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery5ListaDePrecios)
          setProveedorDelivery6CodigoCuentaFinanciera(datosModificadores.VentasPVProveedorDelivery6CuentaFinanciera)
          setProveedorDelivery6CodigoListaPrecios(datosModificadores.VentasPVProveedorDelivery6ListaDePrecios)

          if (localStorage.getItem("CodigoCompania") === "SAI" || localStorage.getItem("CodigoCompania") === "SAL") {
            setVentasPVPermiteVisualizarStock(false)
          }

          const dataProveedoresDelivery = [
            {
              "IdProveedorDelivery": 0,
              "Descripcion": "SIN DELIVERY"
            }
          ];

          //DATOS PROVEEDORES DE DELIVERY
          if (datosModificadores.VentasPVProveedorDelivery1Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 1,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery1
            });
          }

          if (datosModificadores.VentasPVProveedorDelivery2Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 2,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery2
            });
          }

          if (datosModificadores.VentasPVProveedorDelivery3Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 3,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery3
            });
          }

          if (datosModificadores.VentasPVProveedorDelivery4Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 4,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery4
            });
          }

          if (datosModificadores.VentasPVProveedorDelivery5Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 5,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery5
            });
          }

          if (datosModificadores.VentasPVProveedorDelivery6Activo) {
            setPuntoVentaConControlesDelivery(true)
            dataProveedoresDelivery.push({
              "IdProveedorDelivery": 6,
              "Descripcion": datosModificadores.VentasPVProveedorDelivery6
            });
          }

          setDatosProveedorDelivery(dataProveedoresDelivery)

          const resultData = await function_VEN_PVenta_Disposicion_Grupos_Listar();
          setDataGrupos(resultData.data);

          const resultFPData = await function_VEN_PVenta_Disposicion_CuentasFinancieras_ListarDeTerminal(Terminal);
          setDataFormasPago(resultFPData.data);
          setDataFormasPagoTotal(resultFPData.data);

          const resultPlanta = await function_ABM_ZON_Plantas_Leer(localStorage.getItem("CodigoPlanta"))
          setPuntoVentaConBotonFCA(resultPlanta.data[0].PuntoVentaConBotonFCA)
          setPuntoVentaConBotonFCB(resultPlanta.data[0].PuntoVentaConBotonFCB)
          setPuntoVentaConBotonFCC(resultPlanta.data[0].PuntoVentaConBotonFCC)
          setPuntoVentaConBotonFCM(resultPlanta.data[0].PuntoVentaConBotonFCM)
          setPuntoVentaConBotonObservaciones(resultPlanta.data[0].PuntoVentaConBotonObservaciones)
          setPuntoVentaConBotonPedidos(resultPlanta.data[0].PuntoVentaConBotonPedidos)
          setPuntoVentaConBotonTKA(resultPlanta.data[0].PuntoVentaConBotonTKA)
          setPuntoVentaConBotonTKB(resultPlanta.data[0].PuntoVentaConBotonTKB)
          setPuntoVentaConBotonTKM(resultPlanta.data[0].PuntoVentaConBotonTKM)
          setPuntoVentaConBotonTKNCA(resultPlanta.data[0].PuntoVentaConBotonTKNCA)
          setPuntoVentaConBotonTKNCB(resultPlanta.data[0].PuntoVentaConBotonTKNCB)
          setPuntoVentaConBotonTKNCM(resultPlanta.data[0].PuntoVentaConBotonTKNCM)

        } catch (error) {
          alert(error)
        } finally {
          setLoadingGrupos(false); // Asegúrate de que se llame siempre
        }
      };

      functionAsinc();
    }
  }, []);

  useEffect(() => {
    const fetchBotones = async () => {
      if (idGrupo === 0) return; // Solo realiza la carga si IdGrupo tiene un valor válido

      setLoadingBotones(true); // Inicia carga
      try {
        const resultData = await function_VEN_PVenta_Disposicion_Botones_ListarPorGrupo(idGrupo);
        setDataBotones(resultData.data);
      } catch (error) {
        alert(error)
      } finally {
        setLoadingBotones(false); // Termina carga
      }
    };

    fetchBotones();
  }, [idGrupo]);

  useEffect(() => {
    if (statesUpdatedVacio) {
      (async () => {
        try {
          const datosBoton = await function_VEN_PVenta_Disposicion_Botones_Leer(idGrupo, idBotonSeleccionado);
          setCodigoArticulo(datosBoton.data[0].CodigoArticulo);
          setArticulo(datosBoton.data[0].Descripcion);
          setReservable(await TratamientoDeVariableBoolean(datosBoton.data[0].Reservable));

          setCodigoPresentacion(datosBoton.data[0].CodigoPresentacion);
          setCodigoTamano(datosBoton.data[0].CodigoTamano);
          setCodigoUM(datosBoton.data[0].CodigoUnidadMedida);
          setCodigoLP(datosBoton.data[0].CodigoListaPrecios);
          setPresentacion(datosBoton.data[0].Presentacion);
          setTamano(datosBoton.data[0].Tamano);
          setUM(datosBoton.data[0].UnidadMedida);

          setStatesUpdatedLleno(true)
        } catch (error) {
          alert(error)
        } finally {
          // Restablece el estado de `statesUpdatedVacio`
          setStatesUpdatedVacio(false);
          setIdBotonSeleccionado(0);
        }
      })();
    }
  }, [statesUpdatedVacio]);

  useEffect(() => {
    if (statesUpdatedLleno) {
      (async () => {
        try {
          if (reservable) {
            // Lógica para artículos reservables
          } else {
            if (!codigoPresentacion || codigoPresentacion === "") {
              setShowPopupPresentaciones(true);
            }
            if (!codigoTamano || codigoTamano === "") {
              setShowPopupTamanos(true);
            }
            if (!codigoUM || codigoUM === "") {
              setShowPopupUnidadesMedida(true);
            }
          }

          if (codigoArticulo !== "" && codigoPresentacion !== "" && codigoTamano !== "" && codigoUM !== "") {
            //PUEDE AGREGAR

            let resultPrecio
            if (idReserva > 0) {
              const importeNeto = importeReserva / 1.21;
              const importeIVA = importeReserva - importeNeto

              resultPrecio = {
                data: {
                  ImporteTotal: importeReserva,
                  ImporteIVA: importeIVA,
                  ImporteNeto: importeNeto,
                  ImporteBonificacion: 0,
                  ImporteRecargo: 0,
                  ImporteImpuestosInternos: 0,
                  ImporteSubTotal: importeReserva,
                  ImporteSugeridoCompra: 0,
                  ImporteSugeridoVenta: 0,
                  ListaPreciosCodigo: '',
                  ListaPreciosDescripcion: '',
                  PorcentajeIVA: 21,
                  PorcentajeImpuestosInternos: 0
                },
              }
            } else {
              resultPrecio = await function_ABM_ART_Articulos_LeerPrecio(codigoArticulo, codigoPresentacion,
                codigoTamano, codigoUM, idCliente, 0, 1, codigoLP,
                true, "PA")
            }

            const cantidad = cantidadSegunPorcentaje;
            setCantidadSegunPorcentaje(1) //RESETEO y VUELVO A 1

            setJSONDataLocal({
              CodigoArticulo: codigoArticulo,
              CodigoCompania: localStorage.getItem("CodigoCompania"),
              CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
              CodigoPlanta: localStorage.getItem("CodigoPlanta"),
              Articulo: articulo,
              Observaciones: articulo,
              PorcentajeIVA: resultPrecio.data.PorcentajeIVA,
              CodigoPresentacion: codigoPresentacion,
              Presentacion: presentacion,
              CodigoTamano: codigoTamano,
              Tamano: tamano,
              CodigoUnidadMedida: codigoUM,
              UnidadMedida: um,
              Cantidad: cantidad,
              ImporteNeto: resultPrecio.data.ImporteNeto,
              ImporteNetoTotal: resultPrecio.data.ImporteNeto * cantidad,
              ImporteBonificaciones: resultPrecio.data.ImporteBonificacion,
              ImporteBonificacionesTotal: resultPrecio.data.ImporteBonificacion * cantidad,
              ImporteRecargos: resultPrecio.data.ImporteRecargo,
              ImporteRecargosTotal: resultPrecio.data.ImporteRecargo * cantidad,
              ImporteSubTotal: resultPrecio.data.ImporteNeto - resultPrecio.data.ImporteBonificacion + resultPrecio.data.ImporteRecargo,
              ImporteSubTotalTotal: (resultPrecio.data.ImporteNeto - resultPrecio.data.ImporteBonificacion + resultPrecio.data.ImporteRecargo) * cantidad,
              ImporteIVA: resultPrecio.data.ImporteIVA,
              ImporteIVATotal: resultPrecio.data.ImporteIVA * cantidad,
              ImporteImpuestosInternos: resultPrecio.data.ImporteImpuestosInternos,
              ImporteImpuestosInternosTotal: resultPrecio.data.ImporteImpuestosInternos * cantidad,
              ImporteTotal: (resultPrecio.data.ImporteNeto - resultPrecio.data.ImporteBonificacion + resultPrecio.data.ImporteRecargo) + resultPrecio.data.ImporteIVA + resultPrecio.data.ImporteImpuestosInternos,
              ImporteTotalTotal: ((resultPrecio.data.ImporteNeto - resultPrecio.data.ImporteBonificacion + resultPrecio.data.ImporteRecargo) + resultPrecio.data.ImporteIVA + resultPrecio.data.ImporteImpuestosInternos) * cantidad,
              IdItemCotizacion: 0,
              IdItemPedido: 0,
              IdItemRemito: 0,
              I_IdReserva: idReserva,
              IdReserva: idReserva
            })
          }

          if (idReserva > 0) {
            setIdReservaParaCheckIn(idReserva)
          }
          setIdReserva(0)
          setImporteReserva(0)

          setStatesUpdatedLleno(false)
        } catch (error) {
          alert(error)
        } finally {
          // Restablece el estado de `statesUpdatedLleno`
          setStatesUpdatedLleno(false);
          setIdBotonSeleccionado(0);
        }
      })();
    }
  }, [statesUpdatedLleno]);

  useEffect(() => {
    if (datosDetalle.length === 0) {
      setIdProveedorDeliveryReadOnly(false);
    } else {
      setIdProveedorDeliveryReadOnly(true);
    }
  }, [datosDetalle]);

  useEffect(() => {
    if (idReserva > 0) {
      const ejecutar = async () => {
        const resultReserva = await function_VEN_Reservas_Cabecera_Leer(idReserva);
        if (resultReserva.data) {
          if (resultReserva.data.PorcentajeFacturado < 100) {
            const deseaFacturar = window.confirm(
              `La reserva Nº ${idReserva} ha sido seleccionada. ¿Deseas facturarla ahora?`
            );

            if (deseaFacturar) {
              handleonButtOnClick_Facturar();
            }
          } else {
            const deseaCheckIn = window.confirm(
              `La reserva Nº ${idReserva} ha sido seleccionada y se encuentra facturada. ¿Deseas realizar Check In?`
            );

            if (deseaCheckIn) {
              navigate(`/VEN_Reservas_CheckIn/${idReserva}`);
            }
          }
        } else {
          alert("La reserva no existe")
          setIdReserva(0)
        }
      };

      ejecutar();
    }
  }, [idReserva]);

  if (loadingGrupos) {
    return <div>Cargando...</div>;
  }

  return (
    <PaginaCarga
    >
      {autorizacionEnProceso && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          zIndex: 9999
        }}>
          Procesando, por favor espere...
        </div>
      )}

      <table>
        <tbody>
          <tr>
            <td width={anchoBotones + 5} style={{ paddingRight: '5px' }}>
              {loadingGrupos ? (
                <div>Cargando...</div>
              ) : (
                <LVCuadricula
                  data={dataGrupos}
                  IdGrupo={0}
                  CantidadDeBotonesHorizontal={1}
                  AltoBotones={altoBotones}
                  AnchoBotones={anchoBotones}
                  CampoCodigo={"IdGrupo"}
                  CampoDescripcion={"Descripcion"}
                  onButtonClick={handleonButtonClick_Grupo}
                />
              )}
            </td>

            <td width={(anchoBotones * 6) + 5} style={{ paddingRight: '5px' }}>
              {loadingBotones ? (
                <div>Cargando...</div>
              ) : (
                <LVCuadricula
                  data={dataBotones}
                  IdGrupo={0}
                  CantidadDeBotonesHorizontal={6}
                  AltoBotones={altoBotones}
                  AnchoBotones={anchoBotones}
                  CampoCodigo={"IdBoton"}
                  CampoDescripcion={"Descripcion"}
                  onButtonClick={handleonButtonClick_Boton}
                />
              )}
            </td>

            <div style={{ paddingRight: '5px', flexDirection: 'column', margin: '0px', width: '850px', overflowY: 'auto' }}>
              <div className="LV-FlexContainer" style={{ marginLeft: '5px', marginBottom: '5px', alignItems: 'center', gap: '5px' }}>
                <div className="LV-GroupBox-div LV-FlexContainer" style={{ margin: '2px', height: '60px', alignItems: 'center', gap: '4px' }}>
                  <ComboVenListaPreciosCabecera
                    onValueChanged={handleOnValueChanged_CodigoListaPrecios} value={codigoLP}
                    ancho={180} />

                  <LVButtonAccion Texto={"ADMIN."}
                    onClick={() => navigate(`/VEN_PuntoDeVenta_Administracion/${Terminal}`)}
                    Ancho={135}
                  />
                </div>

                {muestraControlesReservas && (
                  <div className="LV-GroupBox-div LV-FlexContainer" style={{ margin: '2px', height: '60px', alignItems: 'center', gap: '4px' }}>
                    <NumberBox
                      visible={muestraControlesReservas}
                      width={80}
                      label="Reserva"
                      value={idReserva}
                      onValueChanged={(e) => { setIdReserva(e.value); }} />

                    <LVButtonAccion
                      Texto={"🔍"}
                      visible={muestraControlesReservas}
                      Ancho={60}
                      Leyenda="BUSCAR"
                      onClick={buscarReservas}
                    />

                    <LVButtonAccion
                      Texto={"➕"}
                      visible={muestraControlesReservas}
                      onClick={() => navigate(`/VEN_Reservas_ModificacionCreacion/${localStorage.getItem("Terminal")}`)}
                      Ancho={60}
                      Leyenda="NUEVA"
                    />

                    <LVButtonAccion
                      Texto={"💲"}
                      visible={muestraControlesReservas}
                      Ancho={60}
                      onClick={handleonButtOnClick_Facturar}
                      Leyenda="FACTURAR"
                    />

                    <LVButtonAccion
                      Texto={"✔️"}
                      visible={muestraControlesReservas}
                      onClick={() => navigate(`/VEN_Reservas_CheckIn`)}
                      Ancho={60}
                      Leyenda="CHECK IN"
                    />

                    <LVButtonAccion
                      Texto={"📌"}
                      visible={muestraControlesReservas}
                      onClick={() => navigate(`/VEN_Reservas_ModificacionCreacionAnexo/${localStorage.getItem("Terminal")}/${idReserva}`)}
                      Ancho={60}
                      Leyenda="ANEXO"
                    />

                    <LVButtonAccion
                      Texto={"🗓️"}
                      visible={muestraControlesReservas}
                      onClick={() => navigate(`/VEN_Reservas_ModificarFecha`)}
                      Ancho={60}
                      Leyenda="EDITAR FECHA"
                    />

                  </div>
                )}
              </div>

              <div style={{ margin: '5px', alignItems: 'center' }}>
                <LV_EEX_Clientes
                  IdCliente={idCliente}
                  setIdParticipante={setIdClienteResponsable}
                />
              </div>

              <div style={{ margin: '0px', alignItems: 'center', gap: '5px' }}>
                {showPopupPresentaciones ? (
                  <>
                    <LVSelectorPresentaciones
                      codigoArticulo={codigoArticulo}
                      onSelectedCodigoChange={handleOnSelectedCodigoChange_Presentacion}
                    />
                  </>
                ) : null}

                {showPopupTamanos ? (
                  <>
                    <LVSelectorTamanos
                      codigoArticulo={codigoArticulo}
                      onSelectedCodigoChange={handleOnSelectedCodigoChange_Tamano}
                    />
                  </>
                ) : null}

                {showPopupUnidadesMedida ? (
                  <>
                    <LVSelectorUnidadesMedida
                      codigoArticulo={codigoArticulo}
                      onSelectedCodigoChange={handleOnSelectedCodigoChange_UnidadMedida}
                    />
                  </>
                ) : null}

                {showPopupPorcentaje ? (
                  <>
                    <LVSelectorPorcentaje
                      idReserva={idReserva}
                      onSelectedCodigoChange={handleOnSelectedCodigoChange_Porcentaje}
                    />
                  </>
                ) : null}

                <div className="LV-GroupBox-div LV-FlexContainer" style={{ margin: '5px', padding: '10px' }}>
                  <RadioGroup
                    items={[
                      { text: "Solo Detalle", value: 0 },
                      { text: "Selector", value: 1 },
                      ...(localStorage.getItem("CodigoCompania") === "000"
                        ? [
                          { text: "Scaneo", value: 2 },
                          { text: "Seña", value: 3 }
                        ]
                        : localStorage.getItem("CodigoCompania") === "307"
                          ? [
                            { text: "Seña", value: 3 }
                          ]
                          : ["SAL", "SAI"].includes(localStorage.getItem("CodigoCompania"))
                            ? [
                              { text: "Scaneo", value: 2 }
                            ]
                            : [])
                    ]}
                    value={comportamiento}
                    onValueChanged={(e) => setComportamiento(e.value)}
                    layout="horizontal"
                    valueExpr="value"
                    displayExpr="text"
                    style={{ margin: '0 10px' }}
                  />
                </div>

                <LV_ART_Articulos_SelectorConGrid
                  jsonParaAgregarDesdeAfuera={jsonDataLocal}
                  idEEX={idCliente}
                  esCompras={false}
                  esVentas={true}
                  codigoListaPrecios={codigoLP}
                  tieneEnCuentaLPdelCliente={true}
                  codigoMonedaEnviadaPorDocumento={codigoMoneda}
                  tienePresentaciones={globalUsaArticulosConPresentacion}
                  tieneTamanos={globalUsaArticulosConTamano}
                  tieneUnidadesMedida={globalUsaArticulosConUnidadDeMedida}
                  DatosDetalle={datosDetalle}
                  DatosConceptoObservaciones={datosConceptoObservaciones}
                  setDatosDetalle={setDatosDetalle}
                  setDatosConceptoObservaciones={setDatosConceptoObservaciones}
                  IdItemMasAlto={idItemMasAlto}
                  Comportamiento={comportamiento}
                  onTotalImporteDelComponenteChange={handleOnTotalImporteDelComponenteChange_}
                  muestraComponentesDelTotal={
                    localStorage.getItem("CodigoCompania") === "MER" ||
                    localStorage.getItem("CodigoCompania") === "MER"
                  }
                  Comprables={0}
                  Vendibles={1}
                  Fabricables={0}
                  Stockeables={0}
                  Servicios={0}
                  ExcluirVendibles={0}
                  ExcluirComprables={0}
                  ExcluirFabricables={0}
                  ExcluirStockeables={0}
                  ExcluirServicios={0}
                  PermiteVisualizarStock={ventasPVPermiteVisualizarStock}
                  PermiteVenderConPrecioCero={ventasPVPermiteVenderConPrecioCero}
                  PuedeModificarPrecios={puntoVentaSePuedenModificarPrecios}
                  pageSize={4} />
              </div>
            </div>

            <td style={{ width: '300' }}>
              <table style={{ height: '100%', width: '100%' }}>
                <tr>
                  <td width={(anchoBotones * 4) + 5} >
                    {loadingFormasPago ? (
                      <div>Cargando...</div>
                    ) : (
                      <>
                        <LVCuadricula
                          data={dataFormasPago}
                          IdGrupo={0}
                          CantidadDeBotonesHorizontal={4}
                          AltoBotones={56}
                          AnchoBotones={anchoBotones}
                          CampoCodigo={"IdBoton"}
                          CampoDescripcion={"Descripcion"}
                          onButtonClick={handleonButtonClick_FPago}
                        />
                      </>
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {puntoVentaConControlesDelivery && (
                      <div className="LV-GroupBox-div LV-FlexContainer">
                        <SBox textoLabel=""
                          textoSelectBox="Proveedor"
                          data={datosProveedorDelivery}
                          campoCodigo="IdProveedorDelivery"
                          campoDescripcion="Descripcion"
                          ancho="250"
                          value={idProveedorDelivery}
                          readOnly={idProveedorDeliveryReadOnly}
                          onValueChanged={(e) => {
                            setIdProveedorDelivery(e.value);
                            setDatosFPago([])

                            const dataOriginal = [...dataFormasPagoTotal];
                            setDataFormasPago(dataOriginal);

                            if (e.value == 1) {
                              if (proveedorDelivery1CodigoListaPrecios && proveedorDelivery1CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery1CodigoListaPrecios)
                              }

                              if (proveedorDelivery1CodigoCuentaFinanciera && String(proveedorDelivery1CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery1CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                            if (e.value == 2) {
                              if (proveedorDelivery2CodigoListaPrecios && proveedorDelivery2CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery2CodigoListaPrecios)
                              }

                              if (proveedorDelivery2CodigoCuentaFinanciera && String(proveedorDelivery2CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery2CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                            if (e.value == 3) {
                              if (proveedorDelivery3CodigoListaPrecios && proveedorDelivery3CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery3CodigoListaPrecios)
                              }

                              if (proveedorDelivery3CodigoCuentaFinanciera && String(proveedorDelivery3CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery3CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                            if (e.value == 4) {
                              if (proveedorDelivery4CodigoListaPrecios && proveedorDelivery4CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery4CodigoListaPrecios)
                              }

                              if (proveedorDelivery4CodigoCuentaFinanciera && String(proveedorDelivery4CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery4CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                            if (e.value == 5) {
                              if (proveedorDelivery5CodigoListaPrecios && proveedorDelivery5CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery5CodigoListaPrecios)
                              }

                              if (proveedorDelivery5CodigoCuentaFinanciera && String(proveedorDelivery5CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery5CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                            if (e.value == 6) {
                              if (proveedorDelivery6CodigoListaPrecios && proveedorDelivery6CodigoListaPrecios != "") {
                                setCodigoLP(proveedorDelivery6CodigoListaPrecios)
                              }

                              if (proveedorDelivery6CodigoCuentaFinanciera && String(proveedorDelivery6CodigoCuentaFinanciera).trim() != "") {
                                const codigos = String(proveedorDelivery6CodigoCuentaFinanciera)
                                  .split(",")
                                  .map(c => c.trim().toUpperCase());

                                const filtrado = dataOriginal.filter(item =>
                                  codigos.includes(String(item.CodigoCuentaFinanciera).trim().toUpperCase())
                                );

                                setDataFormasPago(filtrado);
                              }
                            }
                          }} />
                        {idProveedorDelivery !== 0 && (
                          <>
                            Codigo:
                            <NumberBox width={100} value={codigoOperacionProveedorDelivery} />
                          </>
                        )}
                      </div>
                    )}
                    {puntoVentaConBotonPedidos && (
                      <div className="LV-GroupBox-div LV-FlexContainer">
                        <ComboVenDocsVentaTipos
                          value={idDocVentaTipo}
                          onValueChanged={(e) => { setIdDocVentaTipo(e.value); }}
                          ancho="400" />
                      </div>
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="LV-GroupBox-div LV-FlexContainer">
                      <LVGridCarga
                        dataSource={datosFPago}
                        id="gridContainer"
                        keyExpr="CodigoCuentaFinanciera"
                        AnchoBotonera="38"
                      >
                        <Summary>
                          <TotalItem
                            column="Importe"
                            showInColumn="Importe"
                            summaryType="sum"
                            customizeText={handleCustomizeTotal}
                            valueFormat="currency" />
                        </Summary>

                        <Column caption="Código" dataField="CodigoCuentaFinanciera" width="80" alignment="Left" dataType="string" allowEditing={false} />
                        <Column caption="Medio Pago" dataField="CuentaFinanciera" width="100%" minWidth="150" alignment="Left" dataType="string" allowEditing={false} />
                        <Column caption="Importe" dataField="Importe" width="100" alignment="Right" dataType="number" format="currency" allowEditing={true} />

                        <Paging defaultPageSize={3} /> {/* Lo pongo en 3 para que el PV no se pase */}
                        <Pager
                          showPageSizeSelector={false}
                        />
                      </LVGridCarga>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <LVCuadricula
                      data={soloNC ? dataCierres.filter(x => x.Descripcion.startsWith("NC")) : dataCierres}
                      Disabled={cierreEnProceso}
                      IdGrupo={0}
                      CantidadDeBotonesHorizontal={4}
                      AltoBotones={50}
                      AnchoBotones={anchoBotones}
                      CampoCodigo={"IdBoton"}
                      CampoDescripcion={"Descripcion"}
                      onButtonClick={handleonButtonClick_Cierre}
                    />
                    {/* Autorizacion de NC */}
                    {mostrarAutorizacion && (
                      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                        <label>Aut.:</label>
                        <ComboAbmEexPersonasAutorizantes
                          value={idPersonaNCAutorizante}
                          Ancho={100}
                          onValueChanged={(e) => setIdPersonaNCAutorizante(e.value)}
                          PuedeAutorizarNC={true}
                        />
                        <label>Pass:</label>
                        <TextBox
                          mode="password"
                          value={passwordNC}
                          onValueChanged={(e) => setPasswordNC(e.value)}
                          width={70}
                        />
                        <LVButtonAccion
                          Texto="✔️"
                          onClick={() => confirmarAutorizacionNC(tipoNC)}
                          Ancho={60}
                        />
                        <LVButtonAccion
                          Texto="❌"
                          onClick={() => setMostrarAutorizacion(false)}
                          Ancho={60}
                        />
                      </div>
                    )}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      {mostrarBuscadorReservas && (
        <div style={{
          background: "#000000a0", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999,
          display: "flex", justifyContent: "center", alignItems: "center"
        }}>
          {loadingReservas ? (
            <div style={{ color: "#fff", fontSize: 24 }}>Cargando...</div>
          ) : (
            <div style={{
              background: "white", padding: 20, borderRadius: 10, width: "85%", height: "80%",
              display: "flex", flexDirection: "column"
            }}>
              <h4>Seleccionar Reserva</h4>

              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
                <label>Rango de Datos</label>
                <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesdeBuscadorReservas} onValueChanged={(e) => setFechaDesdeBuscadorReservas(e.value)} />
                <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHastaBuscadorReservas} onValueChanged={(e) => setFechaHastaBuscadorReservas(e.value)} />
                <LVButtonAccion Texto={"BUSCAR"} onClick={async () => await buscarReservas()} />
              </div>

              <div style={{ flex: 1, width: "100%", height: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
                <LVGridCabeceraReporte
                  dataSource={reservasEncontradas}
                  keyExpr="IdReserva"
                  showBorders={true}
                  columnAutoWidth={true}
                  allowColumnResizing={true}
                  height={"90%"}
                  selectionMode="none"
                  width={"100%"}
                  onRowDblClick={(e) => {
                    setIdReserva(e.data.IdReserva);
                    setMostrarBuscadorReservas(false);
                  }}
                >
                  <Column caption="Código" dataField="IdReserva" width="120" alignment="Right" dataType="number" />
                  <Column caption="F.Creacion" dataField="FechaCreacion" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                  <Column caption="F.Reserva" dataField="FechaInicio" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                  <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />

                  <Column caption="Evento" dataField="EsEvento" width="100" alignment="Center" dataType="boolean" />

                  <Column caption="Cliente" alignment="Center" >
                    <Column caption="Código" dataField="IdClienteGenerador" width="120" alignment="Right" dataType="number" />
                    <Column caption="Descripción" dataField="ClienteGenerador" width="100%" minWidth={100} alignment="Left" dataType="string" />
                    <Column caption="D.N.I." dataField="DNI" width="120" alignment="Right" dataType="string" />
                    <Column caption="F.Nacimiento" dataField="FechaNacimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                  </Column>

                  <Column caption="Reserva" alignment="Center" >
                    <Column caption="F.Inicio" dataField="FechaInicio" width="150" alignment="Right" dataType="date" format={'dd/MM/yyyy HH:MM:ss'} />
                    <Column caption="Origen" dataField="Origen" width="100" alignment="Left" dataType="string" />

                    <Column caption="Importes" alignment="Center">
                      <Column caption="Total" dataField="ImporteTotal" width="120" alignment="Right" dataType="number" format="currency" />
                      <Column caption="% Facturado" dataField="PorcentajeFacturado" width="120" alignment="Right" dataType="number" />
                      <Column caption="% Recibido" dataField="PorcentajeRecibido" width="120" alignment="Right" dataType="number" />
                    </Column>
                  </Column>
                  <Paging defaultPageSize={10} />
                </LVGridCabeceraReporte>
              </div>

              <LVButtonAccion Texto={"CERRAR"} onClick={() => setMostrarBuscadorReservas(false)} />
            </div>
          )}
        </div>
      )}
    </PaginaCarga>
  );
};
